// Main Banner
$(document).ready(() => {
  const $slider = $('.main-banner-slider');
  const $children = $slider.children();
  const total = $children.length.toString().padStart(2, '0');

  $children.each((i, slide) => {
    $(slide).prepend(
      `<div class="slick-numbers">${(i + 1).toString().padStart(2, '0')}/${total}</div>`
    );
  });
  $slider.slick({
    dots: true,
    arrows: false,
    infinite: false,
    autoplay: true,
    fade: true,
    autoplaySpeed: 3100,
    speed: 1440,
    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    pauseOnFocus: false
  });
});


// Category Slider
$(function(){
  $('.search_by_categories .category_slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 3100,
      speed: 1440,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
          {breakpoint: 1200, settings: {slidesToShow: 4, slidesToScroll: 4}},
          {breakpoint: 990, settings: {slidesToShow: 3, slidesToScroll: 3}},
          {breakpoint: 750, settings: {slidesToShow: 2, slidesToScroll: 2}}
      ]
  });
});

// Featured Products Slider
$(function(){
  $('.featured_products .resource-list').slick({
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 3100,
      speed: 1440,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
          {breakpoint: 990, settings: {slidesToShow: 2, slidesToScroll: 2}},
          {breakpoint: 750, settings: {slidesToShow: 1, slidesToScroll: 1}}
      ]
  });
});

// Edition Slider
$(function(){
  $('.latest_edition .edition_slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 3100,
      speed: 1440,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
          {breakpoint: 1200, settings: {slidesToShow: 3, slidesToScroll: 3}},
          {breakpoint: 990, settings: {slidesToShow: 2, slidesToScroll: 2}},
          {breakpoint: 750, settings: {slidesToShow: 1, slidesToScroll: 1}}
      ]
  });
});


// Animation JS
document.addEventListener("DOMContentLoaded", () => {
    function e() {
        document.querySelectorAll(".animate").forEach(e => {
            const t = window.scrollY + window.innerHeight,
                l = e.getBoundingClientRect().top + window.scrollY;
            t > l && e.classList.add("in-view")
        })
    }
    window.addEventListener("scroll", e), window.addEventListener("resize", e), document.addEventListener("shopify:section:load", e), e(), new MutationObserver(e).observe(document.body, {
        childList: !0,
        subtree: !0
    })
});



// Card Product Shine Animation:
document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".product-card");
  let lastScroll = window.scrollY;
  let isInitialLoad = true;
  const observer = new IntersectionObserver((entries) => {
    const st = window.scrollY;
    const scrollingDown = st > lastScroll;
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      if (isInitialLoad || scrollingDown) {
        entry.target.classList.remove("animate-shine");
        void entry.target.offsetWidth;
        entry.target.classList.add("animate-shine");
      }
    });
    lastScroll = st <= 0 ? 0 : st;
  }, { threshold: 0.5 });
  cards.forEach(card => observer.observe(card));
  window.addEventListener("scroll", () => { isInitialLoad = false; }, { passive: true });
});



// Top Bar Responsive Slider 
$(document).ready(function() {
  function initMobileSlick() {
  if ($(window).width() < 990) {
    if (!$('.top_bar_items .items_wrapper').hasClass('slick-initialized')) {
      $('.top_bar_items .items_wrapper').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
          autoplaySpeed: 3100,
          speed: 1440,
          autoplay: true,
        });
      }
    } else {
        if ($('.top_bar_items .items_wrapper').hasClass('slick-initialized')) {
            $('.top_bar_items .items_wrapper').slick('unslick');
        }
      }
    }
    initMobileSlick();
    $(window).on('resize', function() {
        initMobileSlick();
    });
});

// Product Variant Size
document.addEventListener("DOMContentLoaded", function() {
  const variantSize = document.querySelector(".variant-size");
  if (variantSize && variantSize.textContent.trim() === "0") {
    variantSize.style.display = "none";
  }
});
